import { skadetypeToString } from './meldskade/reducer/skadetype';
import { urler } from './router/router-urler';
import { Bilmerke } from './sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from './types/generated-types';

const APP_CONTEXT_PATH = '/meld-skade-web';
const RESOURCE_FULL_PATH = `${APP_CONTEXT_PATH}/rest/resource`;

const SKADEMELDING_RESOURCE = 'rest/resource/skademelding';
const SKADE_FULL_PATH = `${APP_CONTEXT_PATH}/${SKADEMELDING_RESOURCE}`;

const USER_SERVICE_PATH = 'rest/resource/kunde';
const USER_FULL_PATH = `${APP_CONTEXT_PATH}/${USER_SERVICE_PATH}`;

const FORSIKRINGER_RESOURCE = 'rest/resource/skade/forsikringer';
const FORSIKRINGER_FULL_PATH = `${APP_CONTEXT_PATH}/${FORSIKRINGER_RESOURCE}`;

const RELASJONER_RESOURCE = `${RESOURCE_FULL_PATH}/relasjoner`;

const APP_LOG_PATH = 'rest/resource/log';
export const loggErrorUrl = () => `${APP_CONTEXT_PATH}/${APP_LOG_PATH}/error`;
export const loggWarnUrl = () => `${APP_CONTEXT_PATH}/${APP_LOG_PATH}/warn`;
export const loggInfoUrl = () => `${APP_CONTEXT_PATH}/${APP_LOG_PATH}/info`;

export const hentSkademeldingUrl = () => SKADE_FULL_PATH;
export const sendSkademeldingUrl = () => SKADE_FULL_PATH;

const besvarteSporsmalBaseUrl = `${APP_CONTEXT_PATH}/rest/resource/besvarteSporsmal`;
export const saveBesvarteSporsmalUrl = () => besvarteSporsmalBaseUrl;
export const besvarteSporsmalUrl = (skademldingstype: Skademeldingstype, kundenummer: string) =>
    `${besvarteSporsmalBaseUrl}/${skademldingstype}/${kundenummer}`;

export const hentUserUrl = (skademeldingstype: Skademeldingstype = undefined) => {
    if (skademeldingstype !== undefined) return `${USER_FULL_PATH}?skadetype=${skademeldingstype}`;
    return USER_FULL_PATH;
};

export const kundeHasAvtalerUrl = () => RELASJONER_RESOURCE;

export const hentSporsmalsflytUrl = (skademeldingstype: Skademeldingstype) => {
    return `${SKADE_FULL_PATH}/sporsmalsflyt/${skademeldingstype}`;
};

export const hentBonusUrl = (forsikringsnummer: string, forsikringsversjon: number, skadetype: Skademeldingstype) => {
    return `${FORSIKRINGER_FULL_PATH}/${forsikringsnummer}/${forsikringsversjon}/bonus?skadetype=${skadetype}`;
};

export const hentEgenandelUrl = (forsikringsnummer: string) => {
    return `${FORSIKRINGER_FULL_PATH}/${forsikringsnummer}/egenandel`;
};

export const hentKjorelengdelUrl = (forsikringsnummer: string, forsikringsversjon: number) => {
    return `${FORSIKRINGER_FULL_PATH}/${forsikringsnummer}/${forsikringsversjon}/kjorelengde`;
};

export const hentKlageUrl = () => {
    return '/meld-skade-web/rest/resource/klage/sporsmalsflyt';
};

export const hentVerkstederUrl = (
    postnummer: string,
    bilmerke: Bilmerke,
    skademeldingstype: Skademeldingstype,
    forsikringsnummer: string,
) => {
    return `${RESOURCE_FULL_PATH}/verksteder?postnummer=${postnummer}&bilmerke=${bilmerke.value}&skademeldingstype=${skademeldingstype}&forsikringsnummer=${forsikringsnummer}`;
};

export const hentVedleggUrl = () => {
    return '/meld-skade-web/rest/resource/vedlegg';
};

export const hentEttersendingUrl = (): string => '/meld-skade-web/rest/resource/ettersending';

export const getSkaderUrl = (kundenummer: string, offentligId: string): string =>
    `/meld-skade-web/rest/resource/skader/${kundenummer}/${offentligId}`;

export const hentKlagePostUrl = () => '/meld-skade-web/rest/resource/klage';

export const skadeUrlFromSkadetype = (skadetype: Skademeldingstype) =>
    `${urler().meldSkadeUrl}?skadetype=${skadetypeToString(skadetype)}`;

export const hentContextPath = () => {
    return APP_CONTEXT_PATH;
};

export const hentKeepAliveUrl = () => '/meld-skade-web/rest/resource/keepalive';

export const hentPoststedUrl = (postnummer: string) => {
    return `${RESOURCE_FULL_PATH}/poststed/${postnummer}`;
};

export const navigateToSitecorePage = (url: string): void => {
    window.location.href = url;
};
